(function() {

    function removeCurrencyAndDecimals() {
      const priveWidget = document.querySelector('#prive-widget-injection-point');
      if (!priveWidget) return;

      const allElements = priveWidget.querySelectorAll('*');

      allElements.forEach(function(element) {
        element.childNodes.forEach(function(node) {
          if (node.nodeType === Node.TEXT_NODE) {
            let text = node.textContent;

            text = text.replace(/\s*(USD|CAD)\s*/gi, '');
            text = text.replace(/(\$\d+)\.00\b/g, '$1');

            if (node.textContent !== text) {
              node.textContent = text;
            }
          }
        });
      });
    }

    function init() {
      const checkWidget = setInterval(function() {
        const priveWidget = document.querySelector('#prive-widget-injection-point');
        if (priveWidget) {
          clearInterval(checkWidget);

          removeCurrencyAndDecimals();

          const observer = new MutationObserver(function() {
            removeCurrencyAndDecimals();
          });

          observer.observe(priveWidget, {
            childList: true,
            subtree: true,
            characterData: true
          });
          setInterval(removeCurrencyAndDecimals, 500);
        }
      }, 500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
})();